module.exports = __webpack_public_path__ + "media/images/emblems/Riggisberg-coat_of_arms-85183e17633fd3cd28cae698b70a6eb2.svg";